import Vue from 'vue';
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { ApolloLink } from 'apollo-link';
import { BatchHttpLink } from 'apollo-link-batch-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { authLink } from './authLink';

// Install the vue plugin
Vue.use(VueApollo);

// Http endpoint
const graphqlEndpoint = process.env.VUE_APP_GRAPHQL_ENDPOINT || '';

function createClient(uri: string, cache: InMemoryCache) {
  const httpLink = new BatchHttpLink({ uri, credentials: 'include'});

  const link = [authLink, httpLink];

  return new ApolloClient({
    link: ApolloLink.from(link),
    cache,
    connectToDevTools: true,
  });
}

const memoryCache = new InMemoryCache();

export const graphqlClient = createClient(graphqlEndpoint, memoryCache);

// Call this in the Vue app file
export function createProvider() {
  // Create vue apollo provider
  return new VueApollo({
    clients: {
      graphqlClient,
    },
    defaultClient: graphqlClient,
  });
}

